import { TrlPillCanceled } from './TrlPillCanceled';

export { TrlPillCanceled } from './TrlPillCanceled';
export default TrlPillCanceled;
